import React, { useContext, useState } from 'react';
import { GlobalSiteDataContext } from '../context';
import FallbackHero from '../components/shared/FallbackHero';
import { AffordablePlansDivider, LessThanTenDivider, SchemaRating, WaxingCostPerYear } from '../components';
import { UnlimitedPackage } from '../components/specials/home/UnlimitedPackage';
import { MilanCredit } from '../components/specials/home/MilanCredit';
import { WhatCustomersSay } from '../components/shared/WhatCustomersSay';
import { SignUpModal } from '../components/shared/SignUpModal';
import { withBuilderFallback } from '../hooks/useBuilderFallback';
import SEO from '../components/shared/SEO';

function FallbackSpecialsTemplate() {
  const siteData = useContext(GlobalSiteDataContext);
  const [showSignUpModal, setShowSignUpModal] = useState(false);

  return (
    <main id="specials-page">
      {showSignUpModal && (
        <SignUpModal {...{ siteData, showSignUpModal, setShowSignUpModal }} />
      )}
      <FallbackHero imageAltType="specials" />
      <WaxingCostPerYear globalData={siteData.globalData} />
      <UnlimitedPackage siteData={siteData} />
      <AffordablePlansDivider />
      <MilanCredit setShowSignUpModal={setShowSignUpModal} globalData={siteData.globalData} />
      <SchemaRating />
      <LessThanTenDivider />
      <WhatCustomersSay />
    </main>
  );
}

// Export the component wrapped with Builder.io fallback functionality
export default withBuilderFallback(FallbackSpecialsTemplate, '/specials/', 'page');

// SEO Head component
export const Head = ({ pageContext, location }) => {
  const { origin } = pageContext || {};
  
  return (
    <SEO
      origin={origin}
      location={location}
      title="Laser Hair Removal Specials"
      description="Save on laser hair removal with our incredible specials. Find out how to get smooth skin at a fraction of the normal cost!"
    />
  );
}; 